(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/message/buttons.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/message/buttons.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


(function (svs, $, gsap) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  var DialogButtons = function (_svs$components$dialo) {
    _inherits(DialogButtons, _svs$components$dialo);

    function DialogButtons(options) {
      var _this;

      _classCallCheck(this, DialogButtons);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DialogButtons).call(this));
      _this.log = new svs.core.log.Logger('DialogButtons');
      _this.options = options; 

      _this.scrollButtonVisible = false;
      _this.buttons = [];
      _this.focusCount = 0; 

      _this.defineTypes();

      _this.render();

      return _this;
    }

    _createClass(DialogButtons, [{
      key: "defineTypes",
      value: function defineTypes() {
        if (this.options.type === svs.components.dialog.type.ERROR && this.options.actions.length !== 1) {
          this.log.error('Only 1 action is allowed in an error message.');
        }

        if (this.options.actions) {
          switch (this.options.actions.length) {
            case 1:
              this.options.actions[0].type = svs.components.dialog.button.SECONDARY;
              break;

            case 2:
              this.options.actions[0].type = svs.components.dialog.button.SECONDARY;
              this.options.actions[1].type = svs.components.dialog.button.PRIMARY;
              break;

            default:
              this.log.error('You must define atleast 1 or 2 actions.');
              break;
          }
        }
      }
    }, {
      key: "addScrollButton",
      value: function addScrollButton() {
        var _this2 = this;

        this._scrollButton = document.createElement('button');
        this._scrollButton.className += 'dialog-button dialog-button-primary js-dialog-button-scrollable dialog-button-scrollable';
        this._scrollButton.innerHTML = svs.ui.icon.partials.icon({
          icon: 'menu-down',
          color: 'fc-white',
          size: 200
        });
        new svs.components.RippleEffect(this._scrollButton, function () {
          _this2.emit('scrollToEnd');
        });
        this.el.appendChild(this._scrollButton);
      }
    }, {
      key: "hideScrollButton",
      value: function hideScrollButton() {
        var _this3 = this;

        if (this.scrollButtonVisible) {
          this.log.debug('Hide Scroll Button');
          gsap.to(this.buttonsEl, {
            duration: 0.2,
            y: 0,
            onComplete: function onComplete() {
              if (_this3.focusCount > 0) {
                _this3.setFocus();
              }
            }
          });
          gsap.to(this._scrollButton, {
            duration: 0.2,
            y: 100
          });
          this.scrollButtonVisible = false;
        }
      }
    }, {
      key: "showScrollButton",
      value: function showScrollButton() {
        var _this4 = this;

        if (!this.scrollButtonVisible) {
          if (!this._scrollButton) {
            this.addScrollButton();
          }

          this.log.debug('Show Scroll Button');
          gsap.to(this.buttonsEl, {
            duration: 0.2,
            y: 100
          });
          gsap.to(this._scrollButton, {
            duration: 0.2,
            y: 0,
            onComplete: function onComplete() {
              if (_this4.focusCount > 0) {
                _this4.setFocus();
              }
            }
          });
          this.scrollButtonVisible = true;
        }
      }
    }, {
      key: "toggleTabIndex",
      value: function toggleTabIndex() {
        if (this.scrollButtonVisible) {
          this.buttons.forEach(function (button) {
            button.tabIndex = -1;
          });
          this._scrollButton.tabIndex = 0;
        } else {
          this.buttons.forEach(function (button, i) {
            button.tabIndex = i + 1;
          });

          if (this._scrollButton) {
            this._scrollButton.tabIndex = -1;
          }
        }
      }
    }, {
      key: "setFocus",
      value: function setFocus() {
        document.activeElement && document.activeElement.blur();
        var btn;

        if (!this.scrollButtonVisible) {
          btn = this.buttons[this.buttons.length - 1];
        } else {
          btn = this._scrollButton;
        }

        if (btn) {
          this.toggleTabIndex();
          btn.focus();
        } 


        this.focusCount++;
      }
    }, {
      key: "triggerEscape",
      value: function triggerEscape() {
        if (this.buttons && this.buttons[0] && !this.scrollButtonVisible) {
          this.buttons[0].click();
        } else {
          this.emit('scrollToEnd');
        }
      }
    }, {
      key: "showLoader",
      value: function showLoader(e) {
        this.buttons.forEach(function (button) {
          button.setAttribute('disabled', 'disabled');
        });
        var loader = new svs.components.Loader('.js-dialog-loader');
        var btnWidth = e.target.clientWidth - 24; 

        e.target.innerHTML = '';
        e.target.insertAdjacentHTML('afterbegin', "<div class=\"js-dialog-loader\" style=\"width: ".concat(btnWidth, "px\"></div>"));
        loader.show(200, 'default');
      }
    }, {
      key: "createButtonContainer",
      value: function createButtonContainer() {
        this.el = document.createElement('div');
        this.el.className += 'dialog-button-container';
      }
    }, {
      key: "createButtonWrapper",
      value: function createButtonWrapper() {
        this.buttonsEl = document.createElement('div');
        this.buttonsEl.className += 'dialog-buttons js-dialog-buttons';
      }
    }, {
      key: "createButtons",
      value: function createButtons() {
        var _this5 = this;

        if (this.options.actions) {
          this.options.actions.forEach(function (action) {
            var callback = action.callback; 

            var _button = document.createElement('button');

            _button.className += "dialog-button dialog-button-".concat(action.type);
            _button.innerText = action.title; 

            new svs.components.RippleEffect(_button, function (e) {
              _this5.log.debug('Clicked a button');

              var delayLoader = 0;

              if (action.showLoader) {
                _this5.showLoader(e);

                delayLoader = 500;
              }

              if (callback) {
                setTimeout(function () {
                  _this5.emit('callback', {
                    e: e,
                    callback: callback
                  });
                }, delayLoader);
              } else {
                _this5.emit('close');
              }
            });

            _this5.buttonsEl.appendChild(_button);

            _this5.buttons.push(_button);
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        this.createButtonContainer();
        this.createButtonWrapper();
        this.el.appendChild(this.buttonsEl);
        this.createButtons();
      }
    }]);

    return DialogButtons;
  }(svs.components.dialog.PubSub);

  svs.components.dialog.Buttons = DialogButtons;
})(svs, $, gsap);
 })(window);